import './style/index.less';
import ProductMenu from './ProductMenu';

export * from './ProductMenu';

export default ProductMenu;
